import type { DeepPartial } from '@luna/utils-ts';

import type { BuildingSocietyConfig } from '../ProductsConfig';
import { savings } from './savings-config/AT';
import { loan } from './loan-config/AT';
import { transactions } from './history-config/AT';
import { statements } from './statements-config/AT';

export const buildingSociety: DeepPartial<BuildingSocietyConfig> = {
    transactions,
    statements,
    loan,
    savings,
    layout: {
        productInfo: {
            showProductIdentifier: true,
        },
    },
    overview: {
        enabled: true,
    },
    isNativeAliasChangeAllowed: true,
};
